import {initThemeScripts} from './components/theme-scripts';

export const swup = new Swup({
	containers: ['#content'],
	plugins:    [new SwupBodyClassPlugin()]
});

// run once when page loads
if (document.readyState === 'complete')
{
	init();
}
else
{
	document.addEventListener('DOMContentLoaded', () => init());
}


// triggers right before the content of page is replaced
/*swup.on('willReplaceContent', function () {

	// We kill all scroll triggers so the next pages can recreate them.
	ScrollTrigger.getAll().forEach(t => t.kill());
});*/


// triggers right after the content of the page is replaced
swup.on('contentReplaced', init);


function init() {

	// reset the scroll position to 0
	window.scrollTo(0, 0);

	initThemeScripts();

}